// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-5147e0db] .modal-dialog {\n  min-width: 100% !important;\n  min-height: 100% !important;\n  margin: 0 !important;\n}\n[data-v-5147e0db] .modal-body {\n  padding: 0;\n}\n[data-v-5147e0db] .modal-header {\n  border: none;\n}\n", ""]);
// Exports
module.exports = exports;
